import { Check, Lock } from "lucide-react";

const RAD = { sharp: 3, soft: 10, round: 18 };

export const ThemeSwatch = ({ v, name, active, locked, onClick, testId, children }) => (
  <div className={`rounded-2xl border p-1.5 transition-colors ${active ? "border-amber-500 bg-amber-500/5" : "border-line hover:border-amber-500/40"}`} data-testid={testId}>
    <button onClick={onClick} className="block w-full text-left" title={locked ? "Pro theme" : `Use ${name}`} data-testid={`${testId}-apply`}>
      <div className="h-28 p-3 flex gap-2 overflow-hidden" style={{ background: v.bg, borderRadius: RAD[v.radius] }}>
        <div className="w-9 shrink-0" style={{ background: v.panel, border: `1px solid ${v.line}`, borderRadius: RAD[v.radius] * 0.6 }} />
        <div className="flex-1 p-2.5" style={{ background: v.panel, border: `1px solid ${v.line}`, borderRadius: RAD[v.radius] * 0.6 }}>
          <p className="text-2xl leading-none" style={{ fontFamily: v.heading_font, color: v.text }}>Aa</p>
          <div className="mt-2 h-1.5 w-4/5 rounded-full" style={{ background: v.text, opacity: 0.75 }} />
          <div className="mt-1.5 h-1.5 w-3/5 rounded-full" style={{ background: v.muted, opacity: 0.8 }} />
          <div className="mt-2.5 h-4 w-12" style={{ background: v.accent, borderRadius: v.radius === "sharp" ? 3 : 999 }} />
        </div>
      </div>
    </button>
    <div className="flex items-center gap-2 px-2 pt-2 pb-1">
      <span className="text-sm text-slate-200 truncate flex-1" data-testid={`${testId}-name`}>{name}</span>
      {active && <Check className="w-4 h-4 text-amber-400 shrink-0" data-testid={`${testId}-active`} />}
      {locked && <Lock className="w-3.5 h-3.5 text-slate-500 shrink-0" data-testid={`${testId}-locked`} />}
      {children}
    </div>
  </div>
);
